let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5BDDk")).then(() => parcelRequire('7ZStd'));